import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom'; // Import Link for internal routing
const StadoFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="stado-footer">
      <style>{`
        .stado-footer {
          width: 100%;
          padding: 80px 6% 0;
          background: #07070d;
          background: radial-gradient(60% 40% at 10% 10%, rgba(255, 61, 110, 0.12), transparent 70%),
                      radial-gradient(60% 40% at 90% 90%, rgba(255, 145, 77, 0.1), transparent 70%),
                      linear-gradient(180deg, #07070d, #0a0a11);
          color: #fff;
          font-family: 'Inter', sans-serif;
        }

        .footer-grid {
          display: grid;
          grid-template-columns: 1.4fr 1fr 1fr 1fr;
          gap: 40px;
          max-width: 1200px;
          margin: auto;
          padding-bottom: 60px;
        }

        .footer-logo img {
          width: 140px;
          margin-bottom: 20px;
          display: block;
        }

        .footer-brand-text {
          color: #94a3b8;
          font-size: 14px;
          line-height: 1.7;
          max-width: 300px;
        }

        .footer-column h4 {
          color: #ff3b69;
          font-size: 16px;
          font-weight: 700;
          margin-bottom: 20px;
          letter-spacing: 0.5px;
        }

        .footer-links {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .footer-links li {
          margin-bottom: 12px;
        }

        /* Styling both Link and a tags */
        .footer-links a, .footer-links .route-link {
          color: #cbd5e1;
          text-decoration: none;
          font-size: 14px;
          transition: 0.3s ease;
          display: inline-block;
          cursor: pointer;
        }

        .footer-links a:hover, .footer-links .route-link:hover {
          color: #ff914d;
          transform: translateX(5px);
        }

        .footer-social {
          display: flex;
          gap: 12px;
          margin-bottom: 25px;
        }

        .social-btn {
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
        }

        .social-btn:hover {
          background: linear-gradient(135deg, #ff3b69, #ff914d);
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(255, 59, 105, 0.3);
          border-color: transparent;
        }

        .social-btn img {
          width: 18px;
          filter: brightness(0) invert(1);
        }

        .playstore-badge img {
          height: 40px;
          transition: transform 0.3s ease;
        }

        .playstore-badge:hover img {
          transform: scale(1.05);
        }

        .footer-bottom {
          border-top: 1px solid rgba(255, 255, 255, 0.05);
          padding: 25px 0;
          text-align: center;
        }

        .copyright-gradient {
          font-size: 13px;
          font-weight: 500;
          background: linear-gradient(90deg, #ff3b69, #ff914d);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          letter-spacing: 1px;
        }

        @media (max-width: 900px) {
          .footer-grid { grid-template-columns: 1fr 1fr; }
        }

        @media (max-width: 500px) {
  .stado-footer { padding: 60px 20px 0; }

  .footer-grid { 
    grid-template-columns: 1fr 1fr; 
    gap: 30px;
  }

  .footer-column:first-child, 
  .footer-column:last-child {
    grid-column: span 2;
    text-align: center;
  }

  .footer-column:first-child .footer-brand-text { 
    margin: 0 auto; 
  }

  .footer-social { 
    justify-content: center; 
  }

  .footer-logo img { 
    margin: 0 auto 20px; 
  }

  /* 🔥 CENTER PLAYSTORE BADGE */
  .footer-column:last-child .playstore-badge {
    display: flex;
    justify-content: center;
    margin-top: 18px;
  }
}

      `}</style>

      <div className="footer-grid">
        <motion.div
          className="footer-column"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <div className="footer-logo">
            <Link to="/">
              <img
                src="/logo-dark.png"
                alt="Stado Payroll Logo"
                style={{ cursor: "pointer" }}
              />
            </Link>
          </div>
          <p className="footer-brand-text">
            "Stop chasing paperwork. Start chasing growth."<br />
            Advanced payroll and workforce management built for accuracy and speed.
          </p>
        </motion.div>

        <motion.div
          className="footer-column"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
        >
          <h4>Quick Links</h4>
          <ul className="footer-links">
            <li><Link to="#">SignIn</Link></li>
            <li><Link to="/book-demo">Book Demo</Link></li>

          </ul>
        </motion.div>

        <motion.div
          className="footer-column"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          <h4>Legal</h4>
          <ul className="footer-links">
            {/* LINK TO YOUR NEW PRIVACY PAGE */}
            <li><Link to="/privacy-policy" className="route-link">Privacy Policy</Link></li>

            {/* LINK TO EXTERNAL SITES */}
            <li><Link to="/terms-conditions/" className="route-link">Terms & Conditions</Link></li>
            <li><Link to="/support/" className="route-link">Support</Link></li>
          </ul>
        </motion.div>

        <motion.div
          className="footer-column"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
        >
          <h4>Connect</h4>
          <div className="footer-social">
            <a href="https://www.instagram.com/payroll.stado" className="social-btn"><img src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/instagram.svg" alt="Insta" /></a>
            <a href="https://www.facebook.com/people/Stado-Payroll/61585473567048/" className="social-btn"><img src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/facebook.svg" alt="FB" /></a>
            <a href="https://www.facebook.com/people/Stado-Payroll/61585473567048/" className="social-btn"><img src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/linkedin.svg" alt="In" /></a>
          </div>

          <a href="https://play.google.com/store/apps/details?id=com.stadopayroll.app" className="playstore-badge" target="_blank" rel="noopener noreferrer">
            <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" />
          </a>
        </motion.div>
      </div>

      <div className="footer-bottom">
        <span className="copyright-gradient">
          © {currentYear} STADO PAYROLL. ALL RIGHTS RESERVED.
        </span>
      </div>
    </footer>
  );
};

export default StadoFooter;